import { get } from "Service";

/**
 * ECourts API Service
 * Refactored to match the official eCourts India API documentation (GET-based search).
 */

const getWalletBalance = () => {
  return get({
    subUrl: "ECourts/wallet-balance",
    isAuth: false,
  });
};

const searchByCNR = (cnr: string) => {
  return get({
    subUrl: "ECourts/search-by-cnr",
    params: { cnr },
    isAuth: false,
  });
};

const searchByPartyName = (searchParams: {
  query?: string,
  advocates?: string,
  judges?: string,
  litigants?: string,
  petitioners?: string,
  respondents?: string,
  courtCodes?: string[],
  caseTypes?: string[],
  caseStatuses?: string[],
  judicialSections?: string[],
  courtTypes?: string[],
  stateCodes?: string[],
  filingDateFrom?: string,
  filingDateTo?: string,
  nextHearingDateFrom?: string,
  nextHearingDateTo?: string,
  decisionDateFrom?: string,
  decisionDateTo?: string,
  page?: number,
  pageSize?: number
}) => {
  console.log("searchParams", searchParams);
  return get({
    subUrl: "ECourts/search-global",
    params: searchParams,
    isAuth: false,
  });
};

const getRecentActivity = () => {
  return get({
    subUrl: "ECourts/recent-activity",
    isAuth: false,
  });
};

const getHistoryItem = (id: number) => {
  return get({
    subUrl: `ECourts/history/${id}`,
    isAuth: false,
  });
};

const getOrderDownloadInfo = (cnr: string, filename: string) => {
  return get({
    subUrl: `ECourts/case/${cnr}/order/${filename}`,
    isAuth: false,
    excel: true, // Use excel: true to trigger responseType: 'blob' in Service/index.tsx
  });
};

const ECourtsApi = {
  getWalletBalance,
  searchByCNR,
  searchByPartyName,
  getRecentActivity,
  getHistoryItem,
  getOrderDownloadInfo,
};

export default ECourtsApi;
